import { Box, Collapse, Typography } from '@material-ui/core';
import MuiButton from 'components/Button';
import Cookies from 'js-cookie';
import React from 'react';
import { booleanParser } from 'services/booleanParser';
import { PWA_INSTALLED } from 'services/PWA';

const Android = () => {
	const [deferredPrompt, setDeferredPrompt] = React.useState(null);
	const [isInstallable, setIsInstallable] = React.useState(false);

	const initialValue = booleanParser(Cookies.get('seen_installed_pwa'))
		? JSON.parse(Cookies.get('seen_installed_pwa'))
		: PWA_INSTALLED;

	const [seenPWA, setSeenPWA] = React.useState(initialValue || false);

	React.useEffect(() => {
		Cookies.set('seen_installed_pwa', JSON.stringify(seenPWA), { expires: 300 });
	}, [seenPWA]);

	React.useEffect(() => {
		setSeenPWA(!isInstallable);
	}, [isInstallable]);

	React.useEffect(() => {
		// Listen for the `beforeinstallprompt` event
		const handleBeforeInstallPrompt = (event) => {
			event.preventDefault(); // Prevent the default install banner
			setDeferredPrompt(event); // Save the event for later use
			setIsInstallable(true); // Set flag to show the install button
		};

		// Polyfill for older browsers that don't support beforeinstallprompt
		if (!window.addEventListener) {
			console.log('beforeinstallprompt event is not supported in this browser.');
			return;
		}

		window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

		return () => {
			window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
		};
	}, []);

	const handleInstallClick = () => {
		if (!deferredPrompt) return;

		// Show the install prompt
		deferredPrompt.prompt();

		// Wait for the user to respond to the prompt
		deferredPrompt.userChoice.then((choiceResult) => {
			if (choiceResult.outcome === 'accepted') {
				console.log('User accepted the install prompt');
			} else {
				console.log('User dismissed the install prompt');
			}
			setDeferredPrompt(null); // Clear the prompt
		});
	};

	console.log(
		'isInstallable',
		isInstallable,
		'PWA_INSTALLED',
		PWA_INSTALLED,
		'seenPWA',
		seenPWA,
		'deferredPrompt',
		JSON.stringify(deferredPrompt),
	);

	return (
		<>
			<Collapse in={!seenPWA}>
				<Box
					style={{
						background: '#FFF',
						boxShadow: '0px 24px 40px -8px rgba(0, 0, 0, 0.06)',
						padding: 16,
						justifyContent: 'space-between',
						alignItems: 'center',
						display: !isInstallable || PWA_INSTALLED ? 'none' : 'flex',
						maxWidth: '480px',
						minWidth: '100%',
						margin: '0 auto',
						position: 'absolute',
						top: 0,
						zIndex: 1000,
					}}
				>
					<Box>
						<Typography variant="h6" style={{ color: '#25233D', fontWeight: 700, fontSize: '16px' }}>
							نصب نسخه وب اپلیکیشن
						</Typography>
					</Box>

					<Box style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
						<MuiButton style={{ width: '88px' }} onClick={handleInstallClick}>
							نصب
						</MuiButton>
						<MuiButton style={{ padding: 'auto 16px' }} variant="outlined" onClick={() => setSeenPWA(true)}>
							بستن
						</MuiButton>
					</Box>
				</Box>
			</Collapse>
		</>
	);
};

export default Android;
